import { Alert } from "@/components/ui/alert";
import { Link } from 'react-router-dom';
import { translate } from '../../../utils/Common';

const ResetPwdSuccess = () => {
    return (
        <div className='container text-center'>
            <Alert variant="success">
                <h4 className="h4 font-normal">{translate("login.resetpwd.success.title")}</h4>
                <p className="mb-2">{translate("login.resetpwd.success.description1")}</p>
                <p className="mb-2 font-semibold">#{translate("login.resetpwd.success.description2")}</p>
            </Alert>
            <Link to="/login" type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 rounded-pill h-12 rounded-md px-8 text-base uppercase mb-3">{translate("login.resetpwd.success.accept")}</Link>
        </div>
    );
}

export default ResetPwdSuccess;